import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryPacking } from "./thunk";

interface StateType {
  packingList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: StateType = {
  packingList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventoryPackingSlice = createSlice({
  name: "InventoryPacking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryPacking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryPacking.fulfilled, (state, action) => {
        state.loading = false;
        state.packingList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryPacking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Packing List";
      });
  },
});

export default inventoryPackingSlice.reducer;
